import * as React from 'react';
import SubHeader from "components/menu/SubHeader";
import { Card } from "reactstrap";
import { Link } from 'react-router-dom';
import { MyActionsH1, HistoryH1 } from "components/menu/Labels";
import ActionableDocuments from "components/portal/ActionableDocuments";
import ActionableFatigueAssessments from "components/portal/ActionableFatigueAssessment";
import './Home.css';
import { Grid2 } from "@mui/material";
import QuickLinksCard from 'components/ui/QuickLinks';
import NeedDirectionCard from 'components/ui/NeedDirection';
import ApplicationsCard from 'components/ui/Applications';
import { ReactNode } from 'react';
import { FavouritesFilterTraditional, RecentlyActionedFilterTraditional, FavouritesFilterCBTC, RecentlyActionedFilterCBTC } from '../components/ui/DocumentRules';
import { getUserExistingRulebookMode } from '../shared/store/applicationState';
import { RulebookModeEnum, RulebookNameToEnum } from '../shared/enums/rulebook-mode-enum';
import AddEditUserDepartment from '../components/portal/department/AddEditUserDepartment';

interface IHistoryButtonProps {
    children: ReactNode,
    url: string,
    icon?: any
}

const HistoryButton = (props: IHistoryButtonProps) => {
    const Icon = props.icon;    

    return (
        <Link to={props.url} className="history-button">
            <div className="hb-underlay">
                <div className="hb-blue-bit"></div>
                <div className="hb-clear-bit"></div>
            </div>

            <div className="hb-overlay">
                <div className="hb-content">
                    {Icon && <Icon />}
                    {props.children}
                </div>
                <div className="hb-caret-container">
                    <div className="hb-caret">
                    </div>
                </div>
            </div>
        </Link>
    );
};

const DocHistory = () => (
    <Card className="document-history-card">
        <div>
            <div className="mb-5">
                <HistoryH1 />
            </div>
            <HistoryButton icon={RulebookNameToEnum(getUserExistingRulebookMode()) === RulebookModeEnum.Traditional ? RecentlyActionedFilterTraditional.icon :
                RulebookNameToEnum(getUserExistingRulebookMode()) === RulebookModeEnum.CBTC ? RecentlyActionedFilterCBTC.icon : null}
                url={RulebookNameToEnum(getUserExistingRulebookMode()) === RulebookModeEnum.Traditional ? RecentlyActionedFilterTraditional.url :
                    RulebookNameToEnum(getUserExistingRulebookMode()) === RulebookModeEnum.CBTC ? RecentlyActionedFilterCBTC.url : ''}>Recently actioned documents</HistoryButton>
            <HistoryButton icon={RulebookNameToEnum(getUserExistingRulebookMode()) === RulebookModeEnum.Traditional ? FavouritesFilterTraditional.icon :
                RulebookNameToEnum(getUserExistingRulebookMode()) === RulebookModeEnum.CBTC ? FavouritesFilterCBTC.icon : null}
                url={RulebookNameToEnum(getUserExistingRulebookMode()) === RulebookModeEnum.Traditional ? FavouritesFilterTraditional.url :
                    RulebookNameToEnum(getUserExistingRulebookMode()) === RulebookModeEnum.CBTC ? FavouritesFilterCBTC.url : ''}>Favourite documents</HistoryButton>
        </div>
    </Card>
);

const home = () => {
    return (
        <div className="narrow-container">
            <SubHeader />

            <Card className="primary-card">
                <MyActionsH1 />
                <div className="pb-4 primary-card-whitepace">&nbsp;</div>
                <ActionableDocuments maxResults={10} />
                <div className="mt-5" />
                <ActionableFatigueAssessments />
            </Card>

            <div className="mt-5"></div>

            <div className="home-middle">
                <AddEditUserDepartment />
                <Grid2 container spacing={6}>
                    <Grid2 size={{ xs: 12, lg: 6 }} className="document-history-col">
                        <DocHistory />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 6 }} className="need-direction-col">
                        <NeedDirectionCard />
                    </Grid2>
                </Grid2>                
            </div>

            <div className="home-footer">
                <div className="splitter" />
                <Grid2 container >
                    <Grid2 className="quick-links-grid" size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                        <QuickLinksCard />
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                        <ApplicationsCard />
                    </Grid2>
                </Grid2>

                <div className="footer-space"></div>
            </div>
        </div>);
};

export default home;